import { Link } from "react-router-dom";

export const AGE_BADGE_SRC = "/api/media/file/clacton-fireworks/products/e856501d001e474cb19e44f1c704e61f/original.jpg";
const ALT = "Fireworks are available to customers aged 18 and over";

/**
 * Age-restriction (18+) trust badge. Modest, responsive, aspect-ratio preserved.
 * Links to /age-policy only when `linked` (so it doesn't look like a stray button otherwise).
 */
export function AgeBadge({ size = 40, showText = true, linked = true, className = "", textClassName = "" }) {
  const img = (
    <img
      src={AGE_BADGE_SRC}
      alt={ALT}
      width={size}
      height={size}
      loading="lazy"
      style={{ width: size, height: size }}
      className="rounded-full object-contain shrink-0 bg-white/5"
      data-testid="age-badge-img"
    />
  );
  const content = (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="age-badge">
      {img}
      {showText && (
        <span className={`text-xs sm:text-sm text-white/70 leading-tight ${textClassName}`}>
          18+ only. Challenge 25 applies.
        </span>
      )}
    </span>
  );
  if (!linked) return content;
  return (
    <Link to="/age-policy" aria-label="Age policy — 18+ only" className="inline-flex items-center gap-2 hover:opacity-90 transition-opacity" data-testid="age-badge">
      {img}
      {showText && (
        <span className={`text-xs sm:text-sm text-white/70 leading-tight ${textClassName}`}>
          18+ only. Challenge 25 applies.
        </span>
      )}
    </Link>
  );
}

export default AgeBadge;
